import {
    ChangeDetectionStrategy,
    Component,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    ViewEncapsulation
} from "@angular/core";
import { TradeCostAnalysisSummaryResponse } from "../../../../models/api/responses/summary/trade-cost-analysis-summary.response.model";
import { TradeCostAnalysisFormType } from "../../../../models/forms/trade-cost-analysis-form.type";
import { TradeCostAnalysisWidgetComponent } from "../trade-cost-analysis-widget/trade-cost-analysis-widget.component";

@Component({
    selector: "lib-trade-cost-analysis-widget-container",
    imports: [TradeCostAnalysisWidgetComponent],
    templateUrl: "./trade-cost-analysis-widget-container.component.html",
    styleUrl: "./trade-cost-analysis-widget-container.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom
})
export class TradeCostAnalysisWidgetContainerComponent {
    public readonly type: InputSignal<TradeCostAnalysisFormType> = input("live" as TradeCostAnalysisFormType);
    public submitForm: OutputEmitterRef<TradeCostAnalysisSummaryResponse> = output();

    protected submit(tradeCostAnalysisSummaryResponse: TradeCostAnalysisSummaryResponse): void {
        this.submitForm.emit(tradeCostAnalysisSummaryResponse);
    }
}
